import firebase from '../../../config/firebase';

const database = firebase.database();

/**
 * Get Featured Events
 */
export function getEvents (callback) {
    // if (auth.currentUser) {
        database.ref('events').on('value', function (snapshot) {
                const events = snapshot.val();
                callback(true, events, null);
            })

    // } else {
    //     callback(false, null, {code: 401, message: 'Session expired.'});
    // }
}

/**
 * Create new event
 */
export function createNewEvent (data, callback) {
    var newId = database.ref().child('events').push().key;
    data["id"] = newId;

    database.ref('events/' + newId).set(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    })
}

/**
 * Edit event
 */
export function editEvent (id, data, callback) {

    database.ref('events/' + id).set(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    });
}

/**
 * Change featured attribute of Event
 */
export function changeFeature(id, value, callback) {
    database.ref('events/' + id + '/isFeatured').set(value, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, id, null);
        }
    });
}

export function changeStarred(id, value, callback) {
    database.ref('events/' + id + '/isStarred').set(value, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, id, null);
        }
    });
}

/**
 * Delete event
 */
export function deleteEvent(id, callback) {
    database.ref('events').child(id).remove(function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, id, null);
        }
    });
}

export function saveSpecials(data, callback) {
    database.ref('specials').set(data, function (error) {
        if (error) {
            callback(false, error);
        } else {
            callback(true, null);
        }
    })
}

export function loadSpecials(callback) {
    database.ref('specials').once('value')
        .then((snapshot) => {
            const specials = snapshot.val();
            callback(true, specials, null);
        })
}
